<ng-template #templateDisputeDetailPart>
    <div class="modal-billing-repairer-detail">
        <div class="modal-header">
            <div class="d-flex flex-column">
                <h4 class="modal-title">{{ 'support.dispute-detail.header.title' | translate }} - {{orderId}}</h4>
                <span class="modal-subtitle">
                    <span>{{ vehicle }}</span>
                </span>
            </div>
            <button type="button" data-dismiss="modal" aria-label="Close" class="btn-close" (click)="close();"></button>
        </div>
        <div class="modal-body">
            <div class="content">
                @if (disputeDetailPartList.length > 0) {
                    <div class="header">
                        <div class="col-dispute-part-detail col-quantity justify-content-center">
                            {{ 'support.dispute-detail.table.title.quantity' | translate }}
                        </div>
                        <div class="col-dispute-part-detail col-part">
                            {{ 'support.dispute-detail.table.title.part-name' | translate }}
                        </div>
                        <div class="col-dispute-part-detail col-brand">
                            {{ 'support.dispute-detail.table.title.brand' | translate }}
                        </div>
                        <div class="col-dispute-part-detail col-situation">
                            {{ 'support.dispute-detail.table.title.situation' | translate }}
                        </div>
                        <div class="col-dispute-part-detail col-delivery justify-content-end">
                            {{ 'support.dispute-detail.table.title.delivery' | translate }}
                        </div>
                        <div class="col-dispute-part-detail col-price justify-content-end">
                            {{ 'support.dispute-detail.table.title.price' | translate }}
                        </div>
                        <div class="col-dispute-part-detail col-discount justify-content-end">
                            {{ 'support.dispute-detail.table.title.discount' | translate }}
                        </div>
                        <div class="col-dispute-part-detail col-total justify-content-end">
                            {{ 'support.dispute-detail.table.title.total' | translate }}
                        </div>
                    </div>
                    <ng-scrollbar>
                        @for (disputeDetailPart of disputeDetailPartList; track $index;) {
                            <div class="part">
                                <div class="col-dispute-part-detail col-quantity justify-content-center">
                                    {{disputeDetailPart.quantity}}
                                </div>
                                <div class="col-dispute-part-detail col-part">
                                    <span class="truncate" [tooltip]="disputeDetailPart.part">{{disputeDetailPart.part}}</span>
                                </div>
                                <div class="col-dispute-part-detail col-brand">
                                    @if (disputeDetailPart.partType != 1) {
                                        <div class="code">
                                            <div class="truncate" [tooltip]="disputeDetailPart.brand">{{disputeDetailPart.brand}}</div>
                                        </div>
                                    }
                                    <div class="truncate name">{{ disputeDetailPart.partTypeDescription }}</div>
                                </div>
                                <div class="col-dispute-part-detail col-situation">
                                    {{disputeDetailPart.deliveryTypeDescription}}
                                </div>
                                <div class="col-dispute-part-detail col-delivery justify-content-end">
                                    {{disputeDetailPart.deliveryDate | date: 'dd/MM/yyyy' }}
                                </div>
                                <div class="col-dispute-part-detail col-price justify-content-end">
                                    {{disputeDetailPart.price | currency:'R$' }}
                                </div>
                                <div class="col-dispute-part-detail col-discount justify-content-end">
                                    {{disputeDetailPart.discount | currency:' ' }}%
                                </div>
                                <div class="col-dispute-part-detail col-total justify-content-end">
                                    {{disputeDetailPart.total | currency:'R$'  }}
                                </div>
                            </div>
                        }
                    </ng-scrollbar>
                }
            </div>
        </div>
    </div>
    <ngx-ui-loader [loaderId]="'loader-dispute-detail'"></ngx-ui-loader>
</ng-template>
